import ComboBox from "../Shared/ComboBox";

const StatusDropdown = ({
  label,
  onSelect,
  isError,
  defaultSelected,
  data,
  isReadOnly = false,
}) => {
  return (
    <ComboBox
      label={label}
      data={data}
      setQuery={() => {}}
      onSelect={onSelect}
      isError={isError}
      showSelectedResult={true}
      defaultSelected={defaultSelected}
      showChevron={!isReadOnly}
      isReadOnly={isReadOnly}
      disabled={isReadOnly}
    />
  );
};

export default StatusDropdown;